/**
 * Model zur Auswertung der Aufgaben im Test
 * @class service_v3sExerciseTest
 * @memberOf v3sWbtPlayerApp:model
 */

angular.module('v3sWbtPlayerApp').factory('v3sExerciseTest', ["v3sExercise", "v3sExerciseStatus", function (v3sExercise, v3sExerciseStatus) {

    var v3sExerciseTest = function (page, data, config) {
        v3sExercise.apply(this, arguments);

        this.evaluation = {};
        this.config = config;
        this.generalFeedbackVisible = this.config.generalFeedbackVisible;

        if (!!this.config.maxAttempts) {
            this.maxAttempts = this.config.maxAttempts;
        }

        this.minAnswersUpdated = false;
    };

    v3sExerciseTest.prototype = new v3sExercise();

    /**
     * Initialisiert die Daten beim Laden
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     */
    v3sExerciseTest.prototype.init = function () {
        if (this.page.isCompleted()) {
            this.completed = true;
            this.showFeedback();
        } else if (this.completed && this.status == v3sExerciseStatus.NO_ANSWER) {
            this.completed = false;
        }
        this.notifyExerciseChanged();
    };

    /**
     * Fügt ein Aufgaben-Element zu der Auswertung hinzu
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExerciseTest.prototype.addExerciseElement = function (exerciseElement) {
        v3sExercise.prototype.addExerciseElement.call(this, exerciseElement);

        if (this.page.isCompleted()) {
            exerciseElement.complete(this.isAnswered());
        }
    };

    /**
     * Aktualisiert die Aufgabe nach dem ein Element verändert wurde
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExerciseTest.prototype.updateExerciseElement = function (exerciseElement) {

        if (!!this.config.getMinAnswers && !this.minAnswersUpdated) {
            this.minAnswers = this.config.getMinAnswers(this);
            this.minAnswersUpdated = true;
        }

        if (this.config.evaluationVisible) {
            v3sExercise.prototype.updateExerciseElement.call(this, exerciseElement);
        } else {
            this.updateStatus();
            this.complete();
            this.notifyExerciseChanged();
        }
    };

    /**
     * Gibt die Element-Daten letzter Auswertung zurück
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExerciseTest.prototype.getExerciseElementData = function (exerciseElement) {
        if (!!exerciseElement && !!exerciseElement.id) {
            return this.evaluation[exerciseElement.id];
        } else {
            return this.evaluation;
        }
    };

    /**
     * Setzt die Element-Daten letzter Auswertung
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExerciseTest.prototype.setExerciseElementData = function (exerciseElement, data) {
        if (!!exerciseElement && !!exerciseElement.id) {
            this.evaluation[exerciseElement.id] = data;
        }
    };

    /**
     * Schließt die Auswertung ab und aktualisiert den Status und Score der Seite
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     */
    v3sExerciseTest.prototype.complete = function (options) {
        options = options || {};
        if (this.config.evaluationVisible) {
            if (!!options.lastTestEvaluation) {
                this.setLastAttempt();
            }
            v3sExercise.prototype.complete.call(this);
        } else {
            this.completed = (this.status != v3sExerciseStatus.NO_ANSWER) || !!options.lastTestEvaluation;
            this.attempts = this.maxAttempts;
            var score = this.isPassed() ? 100 : 0;
            this.page.evaluate(score);
        }
    };

    /**
     * Gibt zurück, ob die Auswertung der Aufgabe sichtbar ist
     * @memberOf v3sWbtPlayerApp:model.service_v3sExerciseTest
     * @return {bool} Auswertung der Aufgabe ist/wird sichtbar
     */
    v3sExerciseTest.prototype.isExerciseEvaluationVisible = function () {
        return this.config.evaluationVisible;
    };

    /**
     * Gibt zurück, ob die globalen Einstellung zur Navigation ignoriert werden sollen.
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} ob die Einstellung ignoriert werden soll
     */
    v3sExerciseTest.prototype.isIgnoreNavigationSetting = function () {
        return true;
    };


    return v3sExerciseTest;
}]);
